import { useQuickOrderId } from "hooks/show/order";

export enum CartLocalStorageKey {
  QUICK = "quick_products",
  STANDARD = "products",
}

export const useCartLocalStorageKey = () => {
  const quickOrderId = useQuickOrderId();
  if (!quickOrderId) {
    return CartLocalStorageKey.STANDARD;
  }
  return CartLocalStorageKey.QUICK;
};
